import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { PanicAlertSelectListRequest } from "./panic-alert-select-list-request";

@Injectable()
export class DataService_PanicAlertMaintenance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	PanicAlertSelectList(parms: PanicAlertSelectListRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PanicAlertSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PanicAlertToggle(PortalPanicAlertID: number, ChangeTo: number) {
		var postResult$ = new Subject();
		var url = "PortalApps/PanicAlertToggle?PortalPanicAlertID=" + PortalPanicAlertID + "&ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PanicAlertDelete(PortalPanicAlertID: number) {
		var postResult$ = new Subject();
		var url = "PortalApps/PanicAlertDelete?PortalPanicAlertID=" + PortalPanicAlertID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
